export const categories = [
  {
    id: 'zhengjie',
    name: '政界揭秘',
    slug: 'zhengjie',
    description: '深度解读政界内部不为人知的幕后故事与权力博弈',
    icon: 'ri-government-line',
    articleCount: 128,
  },
  {
    id: 'yule',
    name: '娱乐圈黑料',
    slug: 'yule',
    description: '娱乐圈明星八卦、内幕交易、潜规则全揭露',
    icon: 'ri-movie-2-line',
    articleCount: 256,
  },
  {
    id: 'shangjie',
    name: '商界内幕',
    slug: 'shangjie',
    description: '商业巨头的暗箱操作、资本游戏与行业黑幕深扒',
    icon: 'ri-briefcase-4-line',
    articleCount: 93,
  },
  {
    id: 'keji',
    name: '科技圈爆料',
    slug: 'keji',
    description: '科技巨头的数据隐私、技术垄断与创新背后的争议',
    icon: 'ri-cpu-line',
    articleCount: 67,
  },
  {
    id: 'shehui',
    name: '社会万象',
    slug: 'shehui',
    description: '社会热点事件背后的真相调查与深度追踪',
    icon: 'ri-global-line',
    articleCount: 184,
  },
  {
    id: 'lishi',
    name: '历史解密',
    slug: 'lishi',
    description: '被掩盖的历史真相与未解之谜的独家档案',
    icon: 'ri-history-line',
    articleCount: 45,
  },
  {
    id: 'jinrong',
    name: '金融暗流',
    slug: 'jinrong',
    description: '金融市场的幕后操纵、洗钱网络与资本骗局',
    icon: 'ri-money-dollar-circle-line',
    articleCount: 72,
  },
  {
    id: 'guoji',
    name: '国际风云',
    slug: 'guoji',
    description: '国际关系背后的谍战、外交博弈与地缘暗战',
    icon: 'ri-earth-line',
    articleCount: 58,
  },
];

export const articles = [
  {
    id: 1,
    slug: 'jumin-quanqiujinrong-heimu',
    title: '揭秘全球金融巨头背后的暗箱操作：万亿资金如何悄然流转',
    excerpt: '深度调查显示，多家国际金融巨头通过复杂的离岸架构，在监管盲区中完成了数万亿资金的转移与洗白。本报道首次揭露了这些操作的完整链条。',
    content: `<p>在全球金融体系的华丽外表之下，隐藏着一张错综复杂的暗网。根据本平台历时六个月的深度调查，多家国际金融巨头通过一系列精心设计的离岸架构，在监管的灰色地带中完成了惊人的资金流转。</p><p>调查团队追踪了超过二十家位于开曼群岛、英属维尔京群岛和百慕大的壳公司，发现它们之间存在着密切的资金往来。这些公司的实际控制人，往往指向同一批华尔街精英。</p><p><strong>核心发现：</strong></p><p>一、通过"三角贸易"模式，将利润转移至低税率地区，每年逃税规模超过500亿美元。</p><p>二、利用高频交易算法的漏洞，在市场波动中获取超额利润，而这些算法的源代码从未向监管机构完整披露。</p><p>三、多家中资企业卷入其中，成为资金流转链条中的关键环节。</p><p>一位不愿具名的前投行高管向本平台透露："这些操作在业内根本不是秘密，只是没人敢公开说罢了。监管机构和金融机构之间有一道看不见的旋转门。"</p><p>本报道将持续追踪这一事件的后续发展，敬请关注。</p>`,
    category: 'jinrong',
    categoryName: '金融暗流',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20financial%20district%20at%20night%20with%20glowing%20skyscrapers%20and%20shadowy%20figures%20in%20suits%2C%20dramatic%20lighting%2C%20cinematic%20atmosphere%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20noir%20style%2C%20high%20contrast%2C%20moody%20and%20suspenseful&width=1200&height=675&seq=article-finance-01&orientation=landscape',
    author: '深度调查组',
    publishDate: '2026-08-03',
    readTime: 12,
    views: 128500,
    tags: ['金融', '洗钱', '离岸', '华尔街'],
    isHot: true,
    isFeatured: true,
  },
  {
    id: 2,
    slug: 'yulequan-qianquizhe-jiemi',
    title: '娱乐圈"选角潜规则"完整链条曝光：从试镜到签约的灰色地带',
    excerpt: '多位业内人士匿名爆料，揭露了影视行业选角过程中的利益输送、裙带关系以及不为人知的交易规则。',
    content: `<p>光鲜亮丽的红毯背后，隐藏着怎样的暗流？本平台专访了七位在影视行业工作超过十年的业内人士，他们以匿名方式，揭开了选角过程中的层层黑幕。</p><p>一位资深选角导演透露："表面上是通过试镜选拔，但实际上，绝大多数重要角色在试镜之前就已经确定了人选。投资方的意志、经纪公司的博弈、以及私人关系的运作，才是决定角色归属的真正因素。"</p><p><strong>调查揭示的五大潜规则：</strong></p><p>一、"带资进组"——投资方指定演员已成为行业公开的秘密，片酬直接从投资款中划拨。</p><p>二、"打包交易"——经纪公司将多位艺人捆绑销售，制作方若想签约一线明星，必须同时接纳其公司的新人。</p><p>三、"数据造假"——部分流量明星的社交媒体数据、票房数据存在系统性造假，以维持其商业价值。</p><p>四、"评奖内定"——多个重要奖项的评选过程受到资本干预，获奖名单在颁奖前早已确定。</p><p>五、"黑公关产业链"——行业内存在完整的水军和黑公关网络，用于操控舆论、打击竞争对手。</p>`,
    category: 'yule',
    categoryName: '娱乐圈黑料',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20behind%20the%20scenes%20of%20film%20set%20with%20dim%20lighting%20and%20shadowy%20silhouettes%2C%20empty%20director%20chair%20under%20spotlight%2C%20dramatic%20noir%20cinematography%2C%20warm%20amber%20accents%2C%20mysterious%20atmosphere%2C%20high%20contrast%20lighting&width=1200&height=675&seq=article-entertain-01&orientation=landscape',
    author: '娱乐圈调查组',
    publishDate: '2026-08-02',
    readTime: 15,
    views: 256800,
    tags: ['娱乐圈', '潜规则', '选角', '影视'],
    isHot: true,
    isFeatured: true,
  },
  {
    id: 3,
    slug: 'keji-gongsi-yinsi-xielou',
    title: '你的手机在"听"你说话：科技巨头隐私侵犯内幕调查',
    excerpt: '多项证据表明，主流智能手机在用户不知情的情况下持续收集语音数据，这些数据被用于精准广告投放和用户画像构建。',
    content: `<p>你是否曾有过这样的经历：刚和朋友聊完某个产品，打开手机就看到了相关广告？这并非巧合。本平台的调查揭示了一个令人不安的真相。</p><p>通过对多款主流智能手机应用的技术分析，调查团队发现至少有十七款常用应用在后台持续激活麦克风权限，即使在用户明确关闭相关权限后，仍可通过系统级漏洞继续收集语音数据。</p><p>一位曾在某科技巨头担任隐私工程师的知情人士透露："公司内部有一个专门的数据标注团队，每天处理数百万条用户语音片段。这些数据被打上标签后，会进入广告推荐系统的训练数据集。"</p>`,
    category: 'keji',
    categoryName: '科技圈爆料',
    coverImage: 'https://readdy.ai/api/search-image?query=Smartphone%20with%20eerie%20glowing%20red%20recording%20indicator%20in%20dark%20room%2C%20data%20streams%20visualized%20as%20flowing%20light%20around%20the%20phone%2C%20dystopian%20surveillance%20theme%2C%20cinematic%20noir%20style%2C%20deep%20shadows%20and%20crimson%20accents&width=1200&height=675&seq=article-tech-01&orientation=landscape',
    author: '科技调查组',
    publishDate: '2026-08-01',
    readTime: 10,
    views: 389200,
    tags: ['科技', '隐私', '数据', '智能手机'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: 4,
    slug: 'zhengjie-gaoguan-caichan-jiemi',
    title: '高层官员海外资产大起底：隐藏在信托背后的巨额财富',
    excerpt: '通过国际调查记者联盟的协作，本平台独家获取了多位高层官员及其亲属在海外的资产分布图谱。',
    content: `<p>在国际调查记者联盟的协作下，本平台获取了一份涉及数十个国家与地区、涵盖超过三千个离岸账户的数据库。经过数据分析团队的仔细梳理，发现了多条与高层官员相关联的资产线索。</p><p>这些资产大多通过多层信托架构持有，利用各国法律之间的差异，形成了严密的保护网。从表面上看，这些信托的受益人往往是官员的远亲或商业伙伴，但追踪资金流向和实际控制关系后，指向逐渐清晰。</p>`,
    category: 'zhengjie',
    categoryName: '政界揭秘',
    coverImage: 'https://readdy.ai/api/search-image?query=Luxurious%20government%20building%20interior%20with%20dim%20dramatic%20lighting%2C%20gold%20accents%20and%20deep%20shadows%2C%20empty%20grand%20hall%20with%20chandeliers%2C%20mysterious%20atmosphere%2C%20cinematic%20noir%20style%2C%20warm%20crimson%20and%20amber%20tones&width=1200&height=675&seq=article-politics-01&orientation=landscape',
    author: '政经调查组',
    publishDate: '2026-07-30',
    readTime: 18,
    views: 452100,
    tags: ['政界', '资产', '离岸', '信托'],
    isHot: true,
    isFeatured: true,
  },
  {
    id: 5,
    slug: 'shehui-shipinanquan-neimu',
    title: '食品安全黑幕：你餐桌上的"特供"蔬菜到底从哪来',
    excerpt: '追踪从农田到餐桌的完整供应链，揭示所谓的"有机""特供"食品背后令人瞠目的真相。',
    content: `<p>"有机认证"的标签背后，究竟有多少是真实的？本平台调查团队历时三个月，跟踪了从种植基地到超市货架的完整供应链，揭开了食品行业中一道触目惊心的黑幕。</p><p>调查发现，部分所谓的"有机农场"实际上与普通农场共用同一块土地，只是在认证检查时进行临时"粉饰"。更有甚者，农药残留超标的蔬菜经过简单清洗后，被重新包装贴上"绿色食品"标签流入市场。</p>`,
    category: 'shehui',
    categoryName: '社会万象',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20industrial%20food%20processing%20facility%20with%20dim%20lighting%2C%20shadowy%20figures%20handling%20vegetables%2C%20contrast%20between%20bright%20organic%20labels%20and%20grimy%20reality%2C%20investigative%20journalism%20style%2C%20noir%20atmosphere%2C%20warm%20amber%20and%20crimson%20accents&width=1200&height=675&seq=article-society-01&orientation=landscape',
    author: '社会调查组',
    publishDate: '2026-07-28',
    readTime: 8,
    views: 298700,
    tags: ['食品', '安全', '有机', '供应链'],
    isHot: false,
    isFeatured: false,
  },
  {
    id: 6,
    slug: 'shangjie-longtouqiye-longduan',
    title: '互联网巨头的"隐形垄断"：你所有的选择其实都是被设计好的',
    excerpt: '通过算法推荐、数据垄断和资本并购，互联网巨头正在构建一个看似自由实则被精准控制的数字世界。',
    content: `<p>当你打开购物应用，看到的"推荐"结果；当你搜索信息，出现在首页的"最佳答案"——这些看似随机的选择，背后都经过了精密的算法设计。而这种设计的目的，并非为你提供最优选择，而是将你引导至能产生最大利润的方向。</p><p>一位曾在某头部互联网公司担任算法工程师的知情人向本平台透露："我们的KPI不是用户满意度，而是点击转化率和停留时长。算法会主动推送那些能引发焦虑、愤怒或恐惧的内容，因为这些情绪能带来最高的互动率。"</p>`,
    category: 'shangjie',
    categoryName: '商界内幕',
    coverImage: 'https://readdy.ai/api/search-image?query=Giant%20digital%20screens%20displaying%20data%20and%20algorithms%20in%20dark%20room%2C%20shadowy%20figure%20controlling%20the%20screens%2C%20dystopian%20tech%20atmosphere%2C%20warm%20crimson%20and%20amber%20glow%2C%20cinematic%20noir%20style&width=1200&height=675&seq=article-business-01&orientation=landscape',
    author: '商界调查组',
    publishDate: '2026-07-26',
    readTime: 14,
    views: 187300,
    tags: ['互联网', '垄断', '算法', '大数据'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: 7,
    slug: 'lishi-mimiwenjian-jiexi',
    title: '解密三十年机密档案：那场改变历史的会议到底发生了什么',
    excerpt: '一批尘封三十年的机密文件近日被解密，揭示了某次关键历史会议中不为人知的激烈博弈与幕后交易。',
    content: `<p>随着三十年保密期限的到期，一批尘封已久的机密档案终于重见天日。本平台历史研究团队耗时两个月，对这些档案进行了系统的梳理与分析，还原了一个个被官方叙事所掩盖的历史细节。</p><p>档案显示，那次被后世称为"转折点"的会议，其实际过程远比公开记载的要复杂和激烈。与会者之间的分歧之大、博弈之激烈，远超外界想象。而最终的"共识"，实际上是在巨大的压力和复杂的利益交换下达成的。</p>`,
    category: 'lishi',
    categoryName: '历史解密',
    coverImage: 'https://readdy.ai/api/search-image?query=Old%20classified%20documents%20scattered%20on%20dark%20wooden%20desk%20under%20warm%20dim%20light%2C%20vintage%20atmosphere%2C%20red%20stamps%20marked%20classified%2C%20dust%20particles%20in%20light%20beam%2C%20noir%20investigative%20style%2C%20amber%20and%20crimson%20tones&width=1200&height=675&seq=article-history-01&orientation=landscape',
    author: '历史研究组',
    publishDate: '2026-07-25',
    readTime: 22,
    views: 165400,
    tags: ['历史', '解密', '档案', '会议'],
    isHot: false,
    isFeatured: true,
  },
  {
    id: 8,
    slug: 'guoji-jiandie-wangluo-baoguang',
    title: '全球最大商业间谍网络被曝光：涉案企业名单触目惊心',
    excerpt: '一份泄露的内部报告显示，一家跨国商业情报机构在过去的十五年间，为超过两百家大型企业提供商业间谍服务。',
    content: `<p>商业间谍，这个通常只在电影中出现的概念，在现实世界中不仅真实存在，而且规模远超人们的想象。一份由内部人士泄露的报告显示，一家注册在瑞士的"商业咨询公司"，实际上是一个覆盖全球的商业间谍网络。</p><p>该机构的核心业务包括：窃取竞争对手的商业机密、监控关键员工、渗透供应链、以及影响政府决策。其客户名单中包括了多家位列世界五百强的知名企业。</p>`,
    category: 'guoji',
    categoryName: '国际风云',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20room%20with%20world%20map%20on%20wall%20showing%20connection%20lines%20between%20cities%2C%20shadowy%20figure%20in%20suit%2C%20documents%20marked%20confidential%2C%20spy%20thriller%20atmosphere%2C%20warm%20amber%20lighting%2C%20cinematic%20noir%20style&width=1200&height=675&seq=article-international-01&orientation=landscape',
    author: '国际调查组',
    publishDate: '2026-07-23',
    readTime: 16,
    views: 213600,
    tags: ['国际', '间谍', '商业', '情报'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: 9,
    slug: 'yule-mingxing-taoshui',
    title: '当红明星"阴阳合同"避税内幕：年入过亿纳税为零的真相',
    excerpt: '税务系统中的惊人漏洞让部分高收入明星通过"阴阳合同"和空壳公司，实现了令人难以置信的避税操作。',
    content: `<p>当普通工薪族每个月看着工资条上的税款扣除时，一些年收入过亿的明星却在享受着近乎为零的实际税率。这不是魔法，而是一套精心设计的避税体系。</p><p>调查发现，这套体系的核心是"阴阳合同"——对外公开的合同金额极低，而实际片酬则通过各种名目的"服务费""咨询费""版权费"等形式，注入明星或其亲属名下的空壳公司。这些公司往往注册在税收优惠地区，享受着极低的税率甚至免税政策。</p>`,
    category: 'yule',
    categoryName: '娱乐圈黑料',
    coverImage: 'https://readdy.ai/api/search-image?query=Luxurious%20backstage%20area%20with%20glamorous%20lighting%20contrasting%20with%20dark%20shadows%2C%20contracts%20and%20money%20on%20table%2C%20hidden%20deals%20theme%2C%20cinematic%20noir%20style%2C%20warm%20amber%20and%20deep%20crimson%20tones&width=1200&height=675&seq=article-entertain-02&orientation=landscape',
    author: '财税调查组',
    publishDate: '2026-07-21',
    readTime: 11,
    views: 567300,
    tags: ['明星', '避税', '合同', '税务'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: 10,
    slug: 'keji-rengongzhineng-weiji',
    title: 'AI正在"学习"你的所有秘密：大模型训练数据的灰色来源',
    excerpt: '主流AI大模型的训练数据中，包含了大量未经授权的个人信息、版权内容甚至敏感数据，而这一切都在"机器学习"的名义下悄然进行。',
    content: `<p>人工智能的飞速发展令人惊叹，但支撑这些进步的"燃料"——训练数据，其来源却充满了灰色地带。调查显示，多家AI公司通过爬虫技术大规模抓取互联网内容，其中包含了大量未经授权的个人隐私信息和版权保护内容。</p><p>更令人担忧的是，一些AI公司与数据经纪商合作，购买了包含个人医疗记录、金融信息和私密对话的数据集，用于训练所谓的"个性化AI助手"。这些行为目前在全球范围内几乎不受监管。</p>`,
    category: 'keji',
    categoryName: '科技圈爆料',
    coverImage: 'https://readdy.ai/api/search-image?query=Artificial%20intelligence%20neural%20network%20visualization%20in%20dark%20room%2C%20glowing%20red%20data%20streams%20flowing%20into%20AI%20core%2C%20dystopian%20surveillance%20theme%2C%20personal%20data%20being%20absorbed%2C%20cinematic%20noir%20style%2C%20crimson%20and%20amber%20accents&width=1200&height=675&seq=article-tech-02&orientation=landscape',
    author: '科技调查组',
    publishDate: '2026-07-20',
    readTime: 13,
    views: 341200,
    tags: ['AI', '数据', '隐私', '大模型'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: 11,
    slug: 'jinrong-xuniguquan-jiaoyisuo',
    title: '虚拟货币交易所"插针"内幕：你的爆仓是被人为制造的',
    excerpt: '多家虚拟货币交易所被指在极端行情中通过"插针"手段，在毫秒级别内制造虚假价格波动，导致大量用户强制爆仓。',
    content: `<p>在虚拟货币的世界里，"插针"是一个令人闻风丧胆的词汇。这个术语描述的是交易所通过短时间内制造极端价格波动，触发大量用户的强制平仓，从而获取巨额利润的行为。</p><p>技术分析显示，这些"针"出现的时间往往只有几百毫秒，在这个时间内，普通用户根本无法做出任何反应。但交易所的做市商算法却可以精准地在这个时间窗口内完成大量交易，以极低的价格收购被强制平仓的资产。</p>`,
    category: 'jinrong',
    categoryName: '金融暗流',
    coverImage: 'https://readdy.ai/api/search-image?query=Cryptocurrency%20trading%20chart%20showing%20dramatic%20crash%20on%20dark%20monitors%2C%20red%20candlestick%20patterns%2C%20shadowy%20server%20room%2C%20digital%20money%20theme%2C%20cinematic%20noir%20style%2C%20deep%20crimson%20and%20amber%20glow&width=1200&height=675&seq=article-finance-02&orientation=landscape',
    author: '金融调查组',
    publishDate: '2026-07-18',
    readTime: 9,
    views: 423600,
    tags: ['虚拟货币', '交易所', '爆仓', '插针'],
    isHot: true,
    isFeatured: false,
  },
  {
    id: 12,
    slug: 'shehui-yiliao-heimu',
    title: '医疗回扣链条完整起底：你的手术费里有多少进了私人腰包',
    excerpt: '从药厂到医生再到医院管理层，一条完整的医疗回扣利益链被揭开，而这笔巨额资金最终由患者买单。',
    content: `<p>每一次走进医院，每一次支付医药费，你可曾想过，这些费用中有多大比例并非用于你的治疗，而是流入了层层利益链条之中？</p><p>本平台调查团队通过长达半年的暗访和数据分析，绘制出了一张触目惊心的医疗回扣地图。从跨国药企的"学术推广费"，到医疗器械商的"技术咨询费"，再到医生个人的"处方提成"，每一个环节都在从患者身上抽取利润。</p>`,
    category: 'shehui',
    categoryName: '社会万象',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20hospital%20corridor%20with%20dim%20lighting%2C%20shadowy%20figures%20exchanging%20envelopes%2C%20medical%20equipment%20in%20background%2C%20corruption%20theme%2C%20cinematic%20noir%20style%2C%20warm%20amber%20and%20crimson%20tones&width=1200&height=675&seq=article-society-02&orientation=landscape',
    author: '医疗调查组',
    publishDate: '2026-07-16',
    readTime: 14,
    views: 312500,
    tags: ['医疗', '回扣', '药价', '腐败'],
    isHot: false,
    isFeatured: false,
  },
];

export const testimonials = [
  {
    id: 1,
    name: '匿名读者A',
    role: '金融行业从业者',
    content: '911黑料的内容深度远超我的预期。每一篇报道都有详实的数据支撑，让我对很多事件有了全新的认识。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20person%20portrait%20in%20dark%20suit%2C%20simple%20dark%20background%2C%20warm%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20style&width=100&height=100&seq=avatar-01&orientation=squarish',
  },
  {
    id: 2,
    name: '匿名读者B',
    role: '媒体从业者',
    content: '作为同行，我深知做深度调查的难度。911黑料的报道质量和选题角度，在行业内绝对是顶尖水平。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20woman%20portrait%20in%20dark%20blazer%2C%20simple%20dark%20background%2C%20warm%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20style&width=100&height=100&seq=avatar-02&orientation=squarish',
  },
  {
    id: 3,
    name: '匿名读者C',
    role: '法律工作者',
    content: '很多报道中揭露的问题，正是我们这个行业长期关注但无力推动改变的。911黑料给了公众一个了解真相的窗口。',
    avatar: 'https://readdy.ai/api/search-image?query=Serious%20man%20portrait%20in%20dark%20attire%2C%20simple%20dark%20background%2C%20warm%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20style&width=100&height=100&seq=avatar-03&orientation=squarish',
  },
];